export default function PageNav () {
	let links = document.querySelectorAll('.onpageMenu-link'),
	anchors = {},
	scrolling = true,
	firstID = '',
	scrollTimeout = null;

	if(!links.length){
		return;
	}

	firstID = links[0].href.split("#")[1];

	[].forEach.call( links, ( el ) => {
		let hash='#'+el.href.split( "#" )[1];
		anchors[ hash ] = el;

		el.onclick = ( ) => { 

			clearTimeOut(scrollTimeout);

			scrollTimeout = setTimeout( () => {

				scrolling = true;
				scroll();

			}, 1000);

			select( el.href ) 
		};

	});
	
	function select( anchor ) {
		let anchorEl = anchors[anchor];

		[].forEach.call(links, (el)=>{
			if(anchorEl!=el) {
				el.classList.remove('onpageMenu-link_active');			
			}
		});

		if( anchor && !anchorEl.classList.contains( 'onpageMenu-link_active' ) ) {

			anchors[anchor].classList.add('onpageMenu-link_active');

		}
	}


	function scroll(){

		if( scrolling ) {

			scrollTimeout = setTimeout( () => {
				scrolling = true;
				scroll();
			}, 500);

			scrolling = false;

			let currentLink,
				currentAnchor,
				currentRect,
				minDistance = 100000; 

			[].forEach.call( links, ( link ) => {

				let id = link.href.split( '#' )[1],
					linked = document.getElementById( id ),
					rect = linked.getBoundingClientRect(),
					distance = Math.abs( rect.top );

				if((distance <  minDistance) ) {
					minDistance = distance;
					currentAnchor = '#' + id;
				}

			});

			select( currentAnchor );
		}
	}
	scroll();
	

}

